import { AppLayout, ContentLayout } from '@amzn/awsui-components-core';
import React from 'react';
import IFrameComponent from 'src/components/das-finsuite/embedded-apps/IFrameComponent';
import { NORMALIZED_STAGE } from 'src/constants/EnvironmentConstants';

/**
 * @feature org-tools
 * @owner das-finsuite-application-dev
 * @description Embeds the Harmony-hosted DaS FinTech Summer Wellness Leaderboard
 * inline within FinSuite. The Harmony app sends no X-Frame-Options and no CSP
 * `frame-ancestors` directive, so it is safe to render in an iframe. The app is a
 * static CloudFront/S3 site, so no FinSuite embed query params are required.
 */

// Stage-aware host. FinSuite and the Harmony websites use DIFFERENT stage names, so this
// mapping is intentionally offset by one: FinSuite has alpha/beta/prod, while the Wellness
// Tracker Harmony app has beta/gamma/prod. Each FinSuite stage embeds the corresponding
// Harmony stage so a pre-prod FinSuite never points at the prod website:
//   FinSuite alpha (incl. personal 'dev') -> Wellness Tracker Harmony beta
//   FinSuite beta                         -> Wellness Tracker Harmony gamma
//   FinSuite prod                         -> Wellness Tracker Harmony prod
// NORMALIZED_STAGE already collapses personal 'dev' desktops to 'alpha'.
const SUMMER_WELLNESS_TRACKER_URL_BY_FINSUITE_STAGE: Record<string, string> = {
  alpha: 'https://das-fintech-wellness-leaderboard.beta.harmony.a2z.com/',
  beta: 'https://das-fintech-wellness-leaderboard.gamma.harmony.a2z.com/',
  prod: 'https://das-fintech-wellness-leaderboard.harmony.a2z.com/'
};

export const SummerWellnessTrackerPage: React.FC = () => {
  // Fall back to the beta (non-prod) website for any unexpected stage so a misconfiguration
  // never leaks the prod website into a pre-prod FinSuite.
  const src = SUMMER_WELLNESS_TRACKER_URL_BY_FINSUITE_STAGE[NORMALIZED_STAGE] ?? SUMMER_WELLNESS_TRACKER_URL_BY_FINSUITE_STAGE.alpha;

  return (
    <AppLayout
      contentType="dashboard"
      disableContentPaddings
      navigationHide
      toolsHide
      maxContentWidth={Number.MAX_VALUE}
      content={
        <ContentLayout disableOverlap>
          <IFrameComponent src={src} title="Wellness Tracker" />
        </ContentLayout>
      }
    />
  );
};

export default SummerWellnessTrackerPage;
